/**
 * A size for something that should give way on short phones: `max` on a phone 844px tall or more,
 * shrinking smoothly to `min` on the shortest we support (640px). Same idea as the lobby's sizes in app.css.
 */
export function fit(min: number, max: number): string {
  const perDvh = (max - min) / 2.04;
  const base = min - perDvh * 6.4;
  return `clamp(${min}px, calc(${+perDvh.toFixed(3)}dvh + ${+base.toFixed(2)}px), ${max}px)`;
}
